var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVkontakteFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#4C75A3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26.352 21.796c.63.61 1.296 1.187 1.86 1.86.25.3.487.608.668.955.256.495.024 1.038-.42 1.067h-2.77c-.714.058-1.284-.228-1.762-.713-.384-.388-.74-.8-1.107-1.202a2.616 2.616 0 0 0-.497-.44c-.378-.244-.706-.17-.922.223-.22.398-.27.84-.29 1.283-.03.648-.227.818-.882.848-1.4.066-2.727-.145-3.96-.846-1.088-.62-1.932-1.492-2.666-2.48-1.43-1.925-2.523-4.04-3.507-6.215-.22-.49-.06-.753.484-.762a75.58 75.58 0 0 1 2.71 0c.366.004.61.213.75.558a16.665 16.665 0 0 0 1.838 3.384c.2.28.403.56.693.758.322.22.567.146.718-.21.096-.225.137-.467.16-.71.07-.83.08-1.66-.045-2.486-.077-.516-.37-.85-.89-.948-.263-.05-.224-.148-.096-.298.223-.26.432-.42.85-.42h3.127c.493.097.602.317.67.81l.002 3.453c-.005.19.096.756.442.883.276.09.46-.13.625-.305.75-.79 1.283-1.723 1.76-2.69.213-.425.395-.866.57-1.307.132-.328.338-.49.71-.482l3.01.004c.09 0 .18 0 .265.016.508.086.647.303.49.795-.247.773-.727 1.417-1.197 2.063-.5.69-1.038 1.358-1.536 2.053-.457.635-.42.955.147 1.506z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkontakteFull);
export default __webpack_public_path__ + "static/media/vkontakte-full.30d6bf98738f712a91726f2aed5f0535.svg";
export { ForwardRef as ReactComponent };